import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M18.121 19.182a1.2 1.2 0 0 0 1.697 0 .3.3 0 0 0 0-.424L13.06 12l6.758-6.758a.3.3 0 0 0 0-.424 1.2 1.2 0 0 0-1.697 0L12 10.94 5.879 4.82a1.2 1.2 0 0 0-1.697 0 .3.3 0 0 0 0 .423L10.939 12l-6.757 6.758a.3.3 0 0 0 0 .424 1.2 1.2 0 0 0 1.697 0l6.12-6.121 6.122 6.12Z" }));
export {
  a as default
};
//# sourceMappingURL=closer-icon-Bx8glUHF.js.map
